import * as React from 'react';

interface IProps {
	location?: any;
	className?: string;
	children?: {};
}

// https://reacttraining.com/react-router/web/guides/scroll-restoration

class ScrollToTop extends React.Component<IProps> {
	public componentDidUpdate(prevProps: any) {
		if (this.props.location !== prevProps.location) {
			window.scrollTo(0, 0);
		}
	}

	public render() {
		return <div className={this.props.className}>{this.props.children}</div>;
	}
}

export default ScrollToTop;
